import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseAddMutation, IAddFn, IGetPostRequest, ITrainingType, ITrainingTypeUpsert } from '../../interfaces'

const getAddTrainingTypeMutationRequest: IGetPostRequest = params => {
  return {
    method: 'post',
    url: `${config.baseUrl}/TrainingTypes`,
  }
}

const useAddTrainingTypeMutation: IUseAddMutation<ITrainingType, ITrainingTypeUpsert> = (params, options = {}) => {
  const request = useMemo(() => getAddTrainingTypeMutationRequest(params), [params])

  const addTraining: IAddFn<ITrainingTypeUpsert, ITrainingType> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingType, Error, any>({
    mutationFn: addTraining,
    ...options,
  })

  return response
}

export default useAddTrainingTypeMutation
